import React, { Component } from "react";
import { MgmContractRequestsProps } from "./MgmContractRequestsListView";
import GridDataView, { GRID_SIZE } from "@my-dld/components/DataView/GridDataView";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { MgmStatusIdToColor } from "@eres/ejari-api/Utils";
import Strings from "@my-dld/assets/strings";
import { MCRequest } from "@eres/ejari-api/Entity/management_contract";
import { LocaleUtil } from "@eres/core";

type Props = MgmContractRequestsProps;

interface State {
	searchKey?: string;
	page: number;
}

class MgmContractRequestsGridView extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			page: 1,
		};
	}

	render() {
		const { items } = this.props;
		const { searchKey } = this.state;
		const filterData = this.getFilterData( searchKey );
		return <GridDataView
			items={ this.getPageData( filterData ) }
			onSearch={ this.onSearch }
			renderGridItem={ ( item: MCRequest, index: number ) => {
				return <RenderGridItem
					key={ `${ index }_${ item.ContractNumber }` }
					item={ item }/>;
			} }
			totalCount={ !isEmptyStringOrNull( searchKey ) ? filterData.length : items.length }
			onPageChange={ this.onPageChange }/>;
	}

	private getPageData( filterData: MCRequest[] ) {
		const { page } = this.state;
		return filterData.slice( ( page - 1 ) * GRID_SIZE, page * GRID_SIZE );
	}

	private getFilterData( sKey?: string ) {
		const { items } = this.props;
		if ( sKey ) {
			return items.filter( ( item: MCRequest ) => {
				const filterKeys: string[] = [];
				filterKeys.push( item.ContractNumber );
				filterKeys.push( LocaleUtil.getLocalValue( { en: item.ContractStatus.NameEn, ar: item.ContractStatus.NameAr } ) );
				filterKeys.push( LocaleUtil.getLocalValue( { en: item.ManagementCompany.NameEn, ar: item.ManagementCompany.NameAr } ) );
				filterKeys.push( item.StartDate.asDate().asSimpleDateString() );
				filterKeys.push( item.EndDate.asDate().asSimpleDateString() );
				filterKeys.push( item.TerminationDate.asDate().asSimpleDateString() );
				filterKeys.push( LocaleUtil.getLocalValue( { en: item.TerminationReason.NameEn, ar: item.TerminationReason.NameAr } ) );
				const fItem = filterKeys.find( ( fKey: string ) => fKey.toLocaleLowerCase().includes( sKey.toLocaleLowerCase() ) );
				return fItem !== undefined;
			} );
		}
		return items;
	}

	private onSearch = ( sKey?: string ) => {
		this.setState( {
			searchKey: sKey,
			page: 1
		} );
	};

	private onPageChange = ( page: number ) => {
		this.setState( { page: page } );
	};
}

function RenderGridItem( props: { item: MCRequest } ) {
	const { item } = props;
	const status = LocaleUtil.getLocalValue( { en: item.ContractStatus?.NameEn, ar: item.ContractStatus?.NameAr } );
	const company = LocaleUtil.getLocalValue( { en: item.ManagementCompany?.NameEn, ar: item.ManagementCompany?.NameAr } );
	const terminateReqDate = item.TerminationDate ? item.TerminationDate.asDate().asSimpleDateString() : undefined;
	const startDate = item.StartDate ? item.StartDate.asDate().asSimpleDateString() : "-";
	const endDate = item.EndDate ? item.EndDate.asDate().asSimpleDateString() : "-";
	const reason = LocaleUtil.getLocalValue( { en: item.TerminationReason?.NameEn, ar: item.TerminationReason?.NameAr } );
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ item.ContractNumber }</span>
							<span>{ Strings.mgm_contract_no }</span>
						</div>
						<span
							className={ "property-status" }
							style={ {
								backgroundColor: "#fff",
								borderColor: MgmStatusIdToColor( item.ContractStatus.Identity ),
								borderWidth: 1,
								borderStyle: "solid",
								color: MgmStatusIdToColor( item.ContractStatus.Identity )
							} }>
                            { status }
                        </span>
					</div>
					<div className="row no-gutters property-card-detail">
						<div className={ "col-12" }>
							<span>{ company }</span>
							<span>{ Strings.company_name }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-detail">
						<div className="col-6">
							<span>{ startDate }</span>
							<span>{ Strings.contract_start_date }</span>
						</div>
						<div className="col-6">
							<span>{ endDate }</span>
							<span>{ Strings.contract_end_date }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-detail">
						<div className="col-6">
							<span>{ terminateReqDate ?? "-" }</span>
							<span>{ Strings.request_date }</span>
						</div>
						<div className="col-6">
							<span>{ reason ?? "-" }</span>
							<span>{ Strings.reason }</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>;
}

export default MgmContractRequestsGridView;